module.exports = "<div class=\"gridster\">\n  <ul>\n  </ul>\n</div>\n"